import type {
  InlineContentRecord,
  InlineNodeType,
  PartialBlockWithTypedContent,
} from './block-content-types';

const BLOCK_NODE_TYPES = new Set<string>([
  'paragraph',
  'heading',
  'bulletListItem',
  'numberedListItem',
  'checkListItem',
  'table',
  'image',
  'video',
  'audio',
  'file',
  'codeBlock',
  'blockquote',
  'horizontalRule',
]);

const INLINE_NODE_TYPES = new Set<InlineNodeType>(['text', 'link', 'token']);

function hasBlockLikeType(node: InlineContentRecord): boolean {
  return typeof node.type === 'string' && BLOCK_NODE_TYPES.has(node.type);
}

function hasInlineType(node: InlineContentRecord): boolean {
  return INLINE_NODE_TYPES.has(node.type as InlineNodeType);
}

/**
 * Keeps only inline nodes inside inline-content blocks. Persisted documents can
 * contain nested block nodes here, which BlockNote cannot render as inline text.
 */
export function sanitizeInlineContent(
  content: PartialBlockWithTypedContent['content'],
): PartialBlockWithTypedContent['content'] {
  if (!Array.isArray(content)) {
    return content;
  }

  return content.filter((node): node is InlineContentRecord => {
    const inlineNode = node as InlineContentRecord;
    return hasInlineType(inlineNode) && !hasBlockLikeType(inlineNode);
  });
}
